import { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ChevronDown, Check, Globe } from 'react-feather';
import './LanguageToggle.css';

export default function LanguageToggle({ showLabel = false, className = '' }) {
  const { language, setLanguage, languages, currentLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    setLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className={`lang-toggle-wrap ${className}`} ref={dropdownRef}>
      <button
        type="button"
        className="lang-toggle-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select language"
        title={`Current Language: ${currentLanguage.name}`}
      >
        <span className="lang-flag">{currentLanguage.flag}</span>
        <span className="lang-code">{currentLanguage.code.toUpperCase()}</span>
        {showLabel && <span className="lang-label">{currentLanguage.name}</span>}
        <ChevronDown size={14} className={`lang-chevron ${isOpen ? 'open' : ''}`} />
      </button>

      {isOpen && (
        <div className="lang-dropdown-menu">
          <div className="lang-dropdown-header">
            <Globe size={13} />
            <span>Select Language</span>
          </div>
          <div className="lang-dropdown-list">
            {languages.map((l) => {
              const isSelected = l.code === language;
              return (
                <button
                  key={l.code}
                  type="button"
                  className={`lang-option-btn ${isSelected ? 'active' : ''}`}
                  onClick={() => handleSelect(l.code)}
                >
                  <span className="option-flag">{l.flag}</span>
                  <div className="option-names">
                    <span className="option-native">{l.nativeName}</span>
                    <span className="option-en">{l.name}</span>
                  </div>
                  {isSelected && <Check size={14} className="option-check" />}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
